import { all, put, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { REQUEST_TOTAL_APPROVED } from './types';

import { totalApprovedSuccess, totalApprovedFailure } from './reducer';

const logger = new Logger('Saga:Dashboard:TotalApproved');

export function* getTotalApproved() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(
      routerService.generate('api.dashboard.leads_total_approved'),
    );

    logger.info('Got total approved data');
    yield put(totalApprovedSuccess(response.data));
  } catch (error) {
    logger.error(error);
    yield put(totalApprovedFailure(error));
  }
}

export default function* totalApprovedSaga() {
  return yield all([takeLatest(REQUEST_TOTAL_APPROVED, getTotalApproved)]);
}
